import React from "react";
import { Phone, Mail, MapPin } from "lucide-react";
import { useLang } from "../LangContext";
import { CONTACT, LOGO_URL } from "../constants";

export default function Footer() {
  const { t } = useLang();
  const year = new Date().getFullYear();
  return (
    <footer className="bg-[#15293f] text-[#FAFAF5] py-16" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          <div>
            <div className="flex items-center gap-3 mb-5">
              <img src={LOGO_URL} alt="Ruizcare" className="h-12 w-12 object-contain bg-white rounded-xl p-1" />
              <div>
                <div className="font-serif-display text-2xl font-semibold">Ruizcare</div>
                <div className="text-[10px] uppercase tracking-[0.22em] text-[#7a8b50] font-semibold">
                  RC Servicios del Hogar
                </div>
              </div>
            </div>
            <p className="text-sm text-[#FAFAF5]/70 leading-relaxed max-w-xs">{t.footer.tagline}</p>
          </div>

          <div>
            <div className="text-[11px] uppercase tracking-[0.22em] text-[#7a8b50] font-semibold mb-4">
              {t.nav.contact}
            </div>
            <ul className="space-y-3 text-sm">
              <li className="flex items-center gap-3">
                <Phone className="h-4 w-4 text-[#7a8b50]" />
                <a href={`tel:${CONTACT.phoneIntl}`} className="hover:text-[#7a8b50]" data-testid="footer-phone">
                  {CONTACT.phoneDisplay}
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="h-4 w-4 text-[#7a8b50]" />
                <a href={`mailto:${CONTACT.email}`} className="hover:text-[#7a8b50]" data-testid="footer-email">
                  {CONTACT.email}
                </a>
              </li>
              <li className="flex items-center gap-3">
                <MapPin className="h-4 w-4 text-[#7a8b50]" />
                <span>{CONTACT.address}</span>
              </li>
            </ul>
          </div>

          <div>
            <div className="text-[11px] uppercase tracking-[0.22em] text-[#7a8b50] font-semibold mb-4">
              {t.contact.hours}
            </div>
            <p className="text-sm text-[#FAFAF5]/80">{t.contact.hoursValue}</p>
          </div>
        </div>

        <div className="mt-14 pt-7 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-[#FAFAF5]/50">
          <div>© {year} Ruizcare · {t.footer.rights}</div>
          <div className="flex items-center gap-5">
            <span>{t.footer.legal}</span>
            <span>{t.footer.privacy}</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
